<template>
  <transition name="component-fade" mode="out-in">
    <div class="modal-mask modal modal-bottom">
      <div class="modal-wrapper" :class="{'middle-modal': alwaysMiddle}">
        <div class="modal-container p-0 modal-content" :class="{ [modalWidth]: true }">
          <form @submit.prevent="$emit('submit')" class="w-100" autocomplete="off" method="post">
            <div class="modal-header border-0 pb-2">
              <slot name="modal-title"></slot>
              <button type="button" class="close mr-0" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body scroll-1 pt-2">
              <div class="w-100 pt-0 pl-2">
                <slot>Modal Body</slot>
              </div>
            </div>
            <div class="modal-footer border-0 pt-0 pb-1" v-if="!hideFooter">
              <slot name="modal-footer">
                <div class="col-md-12 text-right pr-1 pr-md-2">
                  <button @click="$emit('delete')" v-if="btnDelete" type="button" class="btn mt-1 btn-secondary font-size-15 float-left mr-1 px-2 py-0" style="font-size: 15px; height: 40px; line-height: inherit" :disabled="loading">
                    <slot name="delete-text">
                      <span>lóchen</span>
                    </slot>
                  </button>
                  <button @click="$emit('close')" type="button" class="btn btn-default font-size-15 mr-1" :disabled="loading">
                    <slot name="cancel-text">
                      <span>{{$t('cancel')}}</span>
                    </slot>
                  </button>
                  <button :type="isForm ? 'submit' : 'button'" @click="$emit('save')" class="btn btn-primary theme-clr btn-sm font-size-16" :disabled="loading" v-if="showSaveBtn">
                    <i class="spinner-border-sm spinner-border mr-1" v-show="loading"></i>
                    <slot name="save-text"> Ja </slot>
                  </button>
                </div>
              </slot>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>
<script type="application/javascript">
export default {
  props: {
    isForm: {
      required: false,
      default: false,
      type: Boolean
    },
    btnDelete: {
      required: false,
      default: false,
      type: Boolean
    },
    alwaysMiddle: {
      required: false,
      default: false,
      type: Boolean
    },
    modalWidth: {
      required: false,
      default: "col-xl-3",
      type: String
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    },
    hideFooter: {
      required: false,
      default: false,
      type: Boolean
    },
    showSaveBtn: {
      required: false,
      default: true,
      type: Boolean
    },
    disableBodyScroll: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden'
    this.$emit('modalmounted')
    console.log('Modal Mounted')
  },
  beforeDestroy() {
    document.querySelector('body').style.overflow = 'auto'
  }
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.btn-save img,.btn-save i{
  margin-bottom: 3px;
}
.middle-modal{
  vertical-align: middle !important;
}
.modal-container {
  margin: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  transform: translateY(0%) !important;
  min-height: 80px;
}

.modal-mask {
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  background-color: #0000006b;
  display: table;
  transition: opacity 0.4s ease;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.modal-content {
  border-radius: 3px;
  border: none;
}
.modal-header {
  padding-top: 1.25rem !important;
  padding-left: 1.55rem;
}

.modal-header h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
}
button.btn-save,
.modal-footer button.theme-clr{
  padding-inline: 15px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.19);
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  height: 41px;
  color: #FFFFFF;
  border-radius: 5px;
}

button.btn-save:hover {
  color: #fff;
}

button.btn-save svg,.modal-footer button.btn-save svg,.modal-footer button.btn-save .save-svg-img{
  margin-top: -2px;
  margin-right: 4px;
  width: 16px;
}

.modal-footer button.btn-default {
  padding-top: 4px;
  padding-bottom: 4px;
  color: #333333;
  font-weight: 400;
}

.modal-content {
  border-radius: 12px;
  border: none;
}
.modal .vue__time-picker input.display-time {
  padding: 0 .6rem;
  margin-bottom: 8px;
}
.hide-scroll::-webkit-scrollbar {
  display: none;
}


</style>



// WEBPACK FOOTER //
// src/components/custom/ModalPopup.vue